import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import api from "../services/api";
import { login } from "../services/auth";
import ButtonMostrarSenha from "../components/ButtonMostrarSenha";

function Login(props) {
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [url, setUrl] = useState("");
  const [erro, setErro] = useState("");
  // const [mostrarDicaUsuario, setMostrarDicaUsuario] = useState("");
  // const [mostrarDicaSenha, setMostrarDicaSenha] = useState("");

  useEffect(() => {
    var url = window.location.search.split("=");
    url.length - 1 > 0 && setUrl(url);
    document.title = "Login - Segure";
  }, []);

  async function handleLogin(e) {
    e.preventDefault();
    setErro("");
    if (!usuario || !senha) {
      setErro("Preencha os campos!");
    } else {
      await api
        .post(`https://segure.com.br/back-end/api/auth/login`, {
          username: usuario,
          password: senha,
        })
        .then((resposta) => {
          login(resposta.data.access_token);
          url
            ? window.location.replace(url[1])
            : window.location.replace("http://sistema.segure.com.br/");
        })
        .catch((e) => {
          setErro(e.response.data.mensagem);
        });
    }
  }

  return (
    <div
      style={{
        background:
          "no-repeat center url(https://images.wallpaperscraft.com/image/mountains_starry_sky_snow_ice_floes_night_114721_3840x2400.jpg)",
      }}
    >
      <div className="container" style={{ height: "100vh" }}>
        <div className="row h-100 justify-content-center align-items-center text-center">
          <div className="card px-4">
            <form onSubmit={handleLogin} className="m-4">
              <img
                className="mb-4"
                src={"https://segure.com.br/public/logo/logo.svg"}
                alt=""
                width="172"
              />
              <input
                type="text"
                id="nomeUsuario"
                className="form-control mb-4"
                placeholder="Nome de usuário"
                autoFocus={true}
                onChange={(evento) => setUsuario(evento.target.value)}
                required
              />
              {/* <div className="text-left mb-3">
                <small
                  onClick={() => setMostrarDicaUsuario(!mostrarDicaUsuario)}
                  style={{
                    color: "#003972",
                    cursor: "pointer",
                  }}
                >
                  Esqueceu seu usuário?
                </small>
              </div> */}
              <ButtonMostrarSenha
                id="senha"
                placeholder="Senha"
                onChange={(evento) => setSenha(evento.target.value)}
              />
              {/* <div className="text-left mb-3">
                <small
                  onClick={() => setMostrarDicaSenha(!mostrarDicaSenha)}
                  style={{
                    color: "#003972",
                    cursor: "pointer",
                  }}
                >
                  Esqueceu a senha?
                </small>
              </div> */}
              <p className="text-danger">{erro}</p>
              <button className="btn btn-primary btn-block mt-3" type="submit">
                Acessar
              </button>
              <div className="text-left mt-2 mb-5">
                {/* <div>
                  {mostrarDicaUsuario && (
                    <small class="text-muted">
                      <i class="fas fa-question-circle"></i> Usuário:
                      primeiroNome.ultimoNome
                    </small>
                  )}
                </div> */}
                {/* <div>
                  {mostrarDicaSenha && (
                    <small class="text-muted">
                      <i class="fas fa-question-circle"></i> Senha: os primeiros
                      6 dígitos do seu CPF
                    </small>
                  )}
                </div> */}
              </div>
              <p className="mb-3 text-muted">© 2002 - 2020</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(Login);
